import { apiRequest, getResource } from "../api/http";

// Quiz game ("quiz" section): weekly ranking, stats, rewards and messages to players.
const BASE = "/api/admin/quiz";

export const getQuizRanking = (week = 0) => getResource(`${BASE}/ranking?week=${week}`, { fallback: null });
export const getQuizStats = (days = 30) => getResource(`${BASE}/stats?days=${days}`, { fallback: null });
export const getQuizRewards = (page = 1) => getResource(`${BASE}/rewards?page=${page}`, { fallback: null });

/** Exact email (nothing is sent) → `{ to, subject, html }`. */
export const previewQuizReward = (body) => apiRequest("post", `${BASE}/rewards/preview`, { data: body, select: (d) => d.email, rethrow: true });

/** `{ userId, week, tone: "congrats" | "encourage", premiumDays, giftLabel, message, sendEmail }` → the reward. */
export const sendQuizReward = (body) => apiRequest("post", `${BASE}/rewards`, { data: body, select: (d) => d.reward, rethrow: true });

export const apiError = (error) => error?.response?.data?.message || "";
